/**
 * COMPLETE YOUR ROUTINE — multi-select companions → /cart/add.js
 * Opens Reformation cart drawer via section HTML + cart-drawer:open.
 */
(function () {
  'use strict';

  var MONEY_FORMAT =
    (window.theme && theme.settings && theme.settings.money_with_currency_format) ||
    '${{amount}}';

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, MONEY_FORMAT);
      } catch (e) {}
    }
    return (
      '$' +
      value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }

  function getSectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function renderCartSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    getSectionsToRender().forEach(function (section) {
      var root = document.getElementById(section.id);
      if (!root) return;
      var html = parsedState.sections[section.section];
      if (!html) return;
      var target = root.querySelector(section.selector) || root;
      var inner = getSectionInnerHTML(html, section.selector);
      if (inner) target.innerHTML = inner;
      if (section.id === 'Cart-Drawer') {
        if (typeof root.notesToggle === 'function') root.notesToggle();
        if (typeof root.removeProductEvent === 'function') root.removeProductEvent();
      }
    });
  }

  function openCartDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    document.body.classList.add('open-cc', 'open-cart');
    if (drawer) {
      drawer.classList.add('active');
      var recs = drawer.querySelector('.product-recommendations--full');
      if (recs) recs.classList.add('active');
    }
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart-drawer:open');
    } else {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-drawer:open', { bubbles: true })
      );
    }
  }

  function initRoot(root) {
    if (root.dataset.cyrReady) return;
    root.dataset.cyrReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cyr-card]'));
    var totalWrap = root.querySelector('[data-cyr-total-wrap]');
    var totalEl = root.querySelector('[data-cyr-total]');
    var cta = root.querySelector('[data-cyr-cta]');
    var ctaLabel = root.querySelector('[data-cyr-cta-label]');
    var errEl = root.querySelector('[data-cyr-error]');
    var selectAllBtn = root.querySelector('[data-cyr-select-all]');
    var clearBtn = root.querySelector('[data-cyr-clear]');

    var labels = {
      cta: (cta && cta.dataset.labelCta) || 'Add selected to cart',
      empty: (cta && cta.dataset.labelEmpty) || 'Select items to add',
      adding: (cta && cta.dataset.labelAdding) || 'Adding…',
      success: (cta && cta.dataset.labelSuccess) || 'Added to cart'
    };

    function selectedCards() {
      return cards.filter(function (card) {
        var check = card.querySelector('[data-cyr-check]');
        return check && check.checked;
      });
    }

    function variantIdForCard(card) {
      var select = card.querySelector('[data-cyr-variant]');
      if (select) return select.value;
      var fixed = card.querySelector('[data-cyr-variant-fixed]');
      if (fixed) return fixed.value;
      var check = card.querySelector('[data-cyr-check]');
      return check ? check.value : null;
    }

    function priceForCard(card) {
      var select = card.querySelector('[data-cyr-variant]');
      if (select) {
        var opt = select.options[select.selectedIndex];
        return Number(opt && opt.dataset.price) || 0;
      }
      var fixed = card.querySelector('[data-cyr-variant-fixed]');
      if (fixed) return Number(fixed.dataset.price) || 0;
      var check = card.querySelector('[data-cyr-check]');
      return Number(check && check.dataset.price) || 0;
    }

    function syncCard(card) {
      var check = card.querySelector('[data-cyr-check]');
      var select = card.querySelector('[data-cyr-variant]');
      var priceEl = card.querySelector('[data-cyr-price]');
      if (select && check) {
        var opt = select.options[select.selectedIndex];
        if (opt) {
          check.value = opt.value;
          check.dataset.price = opt.dataset.price || '0';
          if (priceEl) priceEl.textContent = formatMoney(opt.dataset.price);
        }
      }
      card.classList.toggle('is-selected', !!(check && check.checked));
    }

    function updateFooter() {
      var selected = selectedCards();
      var total = 0;
      selected.forEach(function (card) {
        total += priceForCard(card);
      });
      if (totalWrap) totalWrap.hidden = selected.length === 0;
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (cta) {
        cta.disabled = selected.length === 0 || cta.classList.contains('is-loading');
      }
      if (ctaLabel && !cta.classList.contains('is-loading')) {
        ctaLabel.textContent = selected.length ? labels.cta : labels.empty;
      }
    }

    function setError(msg) {
      if (!errEl) return;
      if (msg) {
        errEl.hidden = false;
        errEl.textContent = msg;
      } else {
        errEl.hidden = true;
        errEl.textContent = '';
      }
    }

    cards.forEach(function (card) {
      var check = card.querySelector('[data-cyr-check]');
      var select = card.querySelector('[data-cyr-variant]');
      if (check) {
        check.addEventListener('change', function () {
          syncCard(card);
          updateFooter();
          setError(null);
        });
      }
      if (select) {
        select.addEventListener('click', function (e) {
          e.stopPropagation();
        });
        select.addEventListener('change', function () {
          syncCard(card);
          updateFooter();
        });
      }
      syncCard(card);
    });

    if (selectAllBtn) {
      selectAllBtn.addEventListener('click', function () {
        cards.forEach(function (card) {
          var check = card.querySelector('[data-cyr-check]');
          if (check) check.checked = true;
          syncCard(card);
        });
        updateFooter();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        cards.forEach(function (card) {
          var check = card.querySelector('[data-cyr-check]');
          if (check) check.checked = false;
          syncCard(card);
        });
        updateFooter();
      });
    }

    if (cta) {
      cta.addEventListener('click', function () {
        if (cta.disabled) return;
        var selected = selectedCards();
        if (!selected.length) return;

        var items = selected.map(function (card) {
          return { id: Number(variantIdForCard(card)), quantity: 1 };
        }).filter(function (item) {
          return item.id;
        });
        if (!items.length) return;

        setError(null);
        cta.classList.add('is-loading');
        cta.setAttribute('aria-disabled', 'true');
        cta.disabled = true;
        if (ctaLabel) ctaLabel.textContent = labels.adding;

        var sections = getSectionsToRender().map(function (s) {
          return s.section;
        });

        fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: items,
            sections: sections,
            sections_url: window.location.pathname
          })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, status: res.status, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok || result.data.status) {
              var msg =
                (result.data && (result.data.description || result.data.message)) ||
                'Could not add items. Please try again.';
              setError(typeof msg === 'string' ? msg : 'Could not add items. Please try again.');
              return;
            }
            renderCartSections(result.data);
            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('cart:item-added', {
                product: result.data.items ? result.data.items[0] : result.data
              });
            }
            openCartDrawer();
            if (ctaLabel) ctaLabel.textContent = labels.success;
            setTimeout(function () {
              cards.forEach(function (card) {
                var check = card.querySelector('[data-cyr-check]');
                if (check) check.checked = false;
                syncCard(card);
              });
              updateFooter();
            }, 600);
          })
          .catch(function (err) {
            console.error(err);
            setError('Could not add items. Please try again.');
          })
          .finally(function () {
            cta.classList.remove('is-loading');
            cta.removeAttribute('aria-disabled');
            updateFooter();
          });
      });
    }

    updateFooter();
  }

  function boot() {
    document.querySelectorAll('[data-complete-your-routine]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
